import * as React from 'react';
export var title2 = {
  name: 'title2',
  keyCommand: 'title2',
  shortcuts: 'ctrlcmd+2',
  buttonProps: {
    'aria-label': 'Insert title2',
    title: 'Insert title 2'
  },
  icon: /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 16,
      textAlign: 'left'
    }
  }, "Title 2"),
  execute: function execute(state, api) {
    var modifyText = "## ".concat(state.selectedText, "\n");
    if (!state.selectedText) {
      modifyText = "## ";
    }
    api.replaceSelection(modifyText);
  }
};